import { Button, MagellanPopup } from 'components/atoms';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { PiWarning } from 'react-icons/pi';
import Popup from 'reactjs-popup';
import { PopupActions } from 'reactjs-popup/dist/types';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';

export interface IWarningPopupProps {
  open?: boolean;
  onClose?: () => void;
  onConfirm?: (actions: PopupActions) => void;
  confirmButtonVariant?: BUTTON_VARIANT;
  title: string;
  message: string;
  trigger?: JSX.Element;
}

const WarningPopup = ({
  open,
  onClose,
  onConfirm,
  confirmButtonVariant = BUTTON_VARIANT.remove,
  title,
  message,
  trigger,
}: IWarningPopupProps) => {
  const { t } = useTranslation();
  const ref = useRef<PopupActions>(null);

  return (
    <Popup
      ref={ref}
      modal
      nested
      open={open}
      onClose={onClose}
      trigger={trigger ?? <div style={{ display: 'none' }} />}>
      <MagellanPopup>
        <MagellanPopup.Header className='justify-center'>
          <PiWarning />
          {title}
        </MagellanPopup.Header>
        <div className='flex flex-col opacity-55 max-w-96 text-center gap-4 px-24'>
          <p>{message}</p>
          {onConfirm && <p>{t('popup.question')}</p>}
        </div>
        <div className='flex flex-col gap-2 mt-4 px-24'>
          {onConfirm && (
            <Button
              fullWidth
              variant={confirmButtonVariant}
              onClick={() =>
                onConfirm && ref.current && onConfirm(ref.current)
              }>
              <Button.Text text={t('popup.approve')} />
            </Button>
          )}
          <Button
            isClear
            fullWidth
            onClick={() => (onClose ? onClose() : ref.current?.close())}>
            <Button.Text
              text={onConfirm ? t('popup.cancel') : t('popup.close')}
            />
          </Button>
        </div>
      </MagellanPopup>
    </Popup>
  );
};

export default WarningPopup;
